import { Injectable } from '@angular/core'
import { PaymentIntentCreateInput, PaymentIntentUpdateInput, GetStoredPaymentMethodsGQL, PaymentGatewayConfigGQL, AvailablePaymentMethodsGQL, UpdatePaymentIntentGQL, CreatePaymentIntentGQL, SetDefaultPaymentMethodGQL } from '../gql/generated'
import { LoaderService } from './loader.service'
import { tap } from 'rxjs/operators'
import { NzNotificationService } from 'ng-zorro-antd/notification'

@Injectable({
  providedIn: 'root',
})
export class PaymentService {
  constructor(
    private loaderService: LoaderService,
    private nzNotificationService: NzNotificationService,
    private getStoredPaymentMethodsGQL: GetStoredPaymentMethodsGQL,
    private paymentGatewayConfigGQL: PaymentGatewayConfigGQL,
    private availablePaymentMethodsGQL: AvailablePaymentMethodsGQL,
    private setDefaultPaymentMethodGQL: SetDefaultPaymentMethodGQL,
    private updatePaymentIntentGQL: UpdatePaymentIntentGQL,
    private createPaymentIntentGQL: CreatePaymentIntentGQL,
  ) { }
  
  fetchStoredPaymentMethods() {
    return this.loaderService.withLoader(() => {
      return this.getStoredPaymentMethodsGQL
        .fetch(
          { },
          {
            context: {
              headers: {
                'vendure-token': 'K7',
              },
            },
            fetchPolicy: 'network-only',
          }
        )
        .pipe(
          tap({
            next: (response) => {
              const result = response.data.getStoredPaymentMethods
              console.log({result})
            },
          })
        )
    }, PaymentService.name)
  }
  
  fetchPaymentGatewayConfig() { 
    return this.loaderService.withLoader(() => {
      return this.paymentGatewayConfigGQL
        .fetch(
          { },
          {
            context: {
              headers: {
                'vendure-token': 'K7',
              },
            },
            fetchPolicy: 'network-only',
          }
        )
        .pipe(
          tap({
            next: (response) => {
              const result = response.data.paymentGatewayConfig
              console.log({result})
            },
          })
        )
    }, PaymentService.name)
  }
  
  fetchAvailablePaymentMethods() { 
    return this.loaderService.withLoader(() => {
      return this.availablePaymentMethodsGQL
        .fetch(
          { },
          {
            context: {
              headers: {
                'vendure-token': 'K7',
              },
            },
            fetchPolicy: 'network-only',
          }
        )
        .pipe(
          tap({
            next: (response) => {
              const result = response.data.availablePaymentMethods
              console.log({result})
            },
          })
        )
    }, PaymentService.name)
  }
  
  updatePaymentIntent(input: PaymentIntentUpdateInput) { 
    return this.loaderService.withLoader(
      () =>
        this.updatePaymentIntentGQL.mutate(
          { input },
          {
            context: {
              headers: {
                'vendure-token': 'K7',
              },
            }
          }
        )
        .pipe(
          tap({
            next: (response) => {
              const result = response.data?.updatePaymentIntent
              console.log(result)
            },
          })
        ),
      PaymentService.name
    )
  }
  
  createPaymentIntent(input: PaymentIntentCreateInput) { 
    return this.loaderService.withLoader(
      () =>
        this.createPaymentIntentGQL.mutate(
          { input },
          {
            context: {
              headers: {
                'vendure-token': 'K7',
              },
            }
          }
        ).pipe(
          tap({
            next: (response) => {
              const result = response.data?.createPaymentIntent
              console.log(result)
            },
          })
        ),
      PaymentService.name
    )
  }
  
  setDefaultPaymentMethod(paymentMethodId: string) { 
    return this.loaderService.withLoader(
      () =>
        this.setDefaultPaymentMethodGQL.mutate(
          { paymentMethodId },
          {
            context: {
              headers: {
                'vendure-token': 'K7',
              },
            }
          }
        ).pipe(
          tap({
            next: (response) => {
              const result = response.data?.setDefaultPaymentMethod
              console.log(result)
            },
          })
        ),
      PaymentService.name
    )
  }
}